<template>

<body class="as-app-body as-app">
  <div class="as-content">
      <main class="as-main">
      <div id="loader" class="loaded">
        <div class="CDB-LoaderIcon CDB-LoaderIcon--big">
          <h1 class="h1 top">
              Loading ...
          </h1>
        </div>
      </div>
        <div class="as-map-area">
          <div id="map"></div>
          <MapUI />
        </div>
      </main>
      <RightPanel />
  </div>
</body>
</template>

<script>
import { init } from '@/lib/map'
import { mapState } from 'vuex'
import RightPanel from './RightPanel'
import MapUI from './MapUI'
export default {
  name: 'MapContainer',
  props: ['source', 'sourceType', 'viz'],
  components: {
    RightPanel,
    MapUI
  },
  computed: {
    ...mapState({
      featureNb: state => state.featureNb,
      categories: state => state.categories,
      bins: state => state.bins,
      cartoLayer: state => state.cartoLayer
    })
  },
  mounted () {
    init(this.$store)
  },
  methods: {
    displayNum (val, style = {}) {
      const roundedValue = Math.round(val)
      const dollars = new Intl.NumberFormat('fr-CA', style).format(roundedValue)
      return dollars
    }
  }
}
</script>

<style>
#map {
    position: relative;
    display: flex;
    /* height: 50vh !important;
    width: 100%; */
}

.loaded.hide-opacity{
    opacity: 0;
}

.top{
  position: absolute;
  top: 45%;
  left: 50%;
}
.loaded {
    color: #20202c;
    text-align: center;
    transition: opacity 3s ease-in-out;
    opacity: 0.9;
}

#loader {
    background: aliceblue;
    position: absolute;
    z-index: 1000;
    width: 100%;
    height:100%;
    transition: background-color 1s linear;
}
</style>
